/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, Grid, InputAdornment, InputLabel, OutlinedInput, styled, Switch, TextField, Typography } from "@mui/material"
import { CurrencyJSON, FundingSource, handleUndefined, PriceType } from "../../../../../common/const";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../../../common/common";
import { showNotification } from "../../../../../common/Notification/ToastifyNotification";

const DefaultTypo = styled(Typography)(({ theme }) => ({
  color: 'gray',
  fontSize: 10
}));

const DefaultTypo1 = styled(Typography)(({ theme }) => ({
  color: 'red',
  fontSize: 10
}));

const Financial = ({
  itemData,
  projectData,
  items,
  setItems
}) => {
  const [budgetLoading, setBudgetLoading] = useState(false);
  const [budgetData, setBudgetData] = useState([]);

  const getBudget = async () => {
    try {
      setBudgetLoading(true);
      const response = await apiRequest('get', `/budget?projectId=${projectData?.project_id}&pageNo=1&pageSize=100`);
      const { data } = response.data;
      if (data?.length > 0) {
        setBudgetData(data);
      }
      setBudgetLoading(false);
    } catch (error) {
      setBudgetLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    if (projectData) {
      getBudget();
    }
  }, [projectData]);

  return (
    <>
      <Typography variant="body1" sx={{ fontWeight: 600 }}>Financial</Typography>
      <Typography variant="body2" sx={{ fontSize: 12 }}>Quantity, costing and budget information</Typography>
      <Grid container spacing={2} mt={0.3}>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Autocomplete
            value={PriceType.find((c) => c.value === handleUndefined(items?.product_data?.price_type, itemData?.product?.price_type)) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            clearIcon={null}
            options={PriceType}
            getOptionLabel={(option) => option?.name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  price_type: newValue?.value || null
                }
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Price Type *" name="Price Type *" variant="outlined" />}
          />
          {(items?.product_data?.price_type !== undefined && items?.product_data?.price_type !== itemData?.product?.price_type) && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{PriceType?.find((a) => a.value === itemData?.product?.price_type)?.name || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Price *</InputLabel>
            <OutlinedInput
              label="Price *"
              id="standard-adornment-password"
              type='number'
              value={items?.unit_price}
              startAdornment={<InputAdornment position="start">{CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol}</InputAdornment>}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  unit_price: e.target.value
                }))
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
          {Number(items?.unit_price) !== Number(itemData?.product?.list_price) && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.product?.list_price !== null ? itemData?.product?.list_price : 0}` || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Quantity</InputLabel>
            <OutlinedInput
              label="Quantity"
              id="standard-adornment-password"
              type='number'
              value={items?.quantity}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  quantity: e.target.value
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${items?.unit_price !== null ? items.quantity * items?.unit_price : 0}`}</Typography>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Freight</InputLabel>
            <OutlinedInput
              label="Freight"
              id="standard-adornment-password"
              type='number'
              value={items?.freight}
              startAdornment={<InputAdornment position="start">{CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol}</InputAdornment>}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  freight: e.target.value
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Storage</InputLabel>
            <OutlinedInput
              label="Storage"
              id="standard-adornment-password"
              type='number'
              value={items?.storage}
              startAdornment={<InputAdornment position="start">{CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol}</InputAdornment>}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  storage: e.target.value
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Installation</InputLabel>
            <OutlinedInput
              label="Installation"
              id="standard-adornment-password"
              type='number'
              value={items?.installation}
              startAdornment={<InputAdornment position="start">{CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol}</InputAdornment>}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  installation: e.target.value
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Fees</InputLabel>
            <OutlinedInput
              label="Fees"
              id="standard-adornment-password"
              type='number'
              value={items?.fees}
              startAdornment={<InputAdornment position="start">{CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol}</InputAdornment>}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  fees: e.target.value
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Discounts</InputLabel>
            <OutlinedInput
              label="Discounts"
              id="standard-adornment-password"
              type='number'
              value={items?.discounts}
              startAdornment={<InputAdornment position="start">{CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol}</InputAdornment>}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  discounts: e.target.value
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Trade-In</InputLabel>
            <OutlinedInput
              label="Trade-In"
              id="standard-adornment-password"
              type='number'
              value={items?.tradein}
              startAdornment={<InputAdornment position="start">{CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol}</InputAdornment>}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  tradein: e.target.value
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={FundingSource.find((c) => c.value === items?.funding_source) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            clearIcon={null}
            options={FundingSource}
            getOptionLabel={(option) => option.name}
            onChange={(event, newValue) => {
              setItems((prevState) => ({
                ...prevState,
                funding_source: newValue?.value || null
              }));
            }}
            renderInput={(params) => <TextField fullWidth {...params} label="Funding Source *" name="Funding Source *" variant="outlined" />}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Autocomplete
            value={budgetData.find((c) => c.budget_id === items?.budget_id) || null}
            id="combo-box-demo"
            size="small"
            fullWidth
            options={budgetData}
            getOptionLabel={(option) => option?.budget_name}
            onChange={(event, newValue) => {
              setItems((prevData) => ({
                ...prevData,
                budget_id: newValue?.budget_id || null
              }));
            }}
            renderInput={(params) =>
              <TextField
                fullWidth
                {...params}
                label="Budget"
                name="Budget"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {budgetLoading ? <CircularProgress color="primary" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormGroup>
            <FormControlLabel control={<Switch 
              disabled
              checked={projectData?.is_tax_exempt} 
            />} label="This project is tax-exempt" sx={{ '& .MuiFormControlLabel-label': { fontSize: '12px' } }} />
          </FormGroup>
        </Grid>
        <Grid item sm={12} md={6} lg={3}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Tax</InputLabel>
            <OutlinedInput
              label="Tax"
              id="standard-adornment-password"
              type='number'
              value={items?.tax || ''}
              disabled={items?.default_tax_from_project}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  tax: e.target.value
                }));
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                  event.preventDefault();
                }
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={items?.default_tax_from_project} onClick={(e) => {
              setItems((prevState) => ({
                ...prevState,
                default_tax_from_project: e.target.checked,
                tax: e.target.checked === true ? projectData?.tax_rate : itemData?.tax,
                is_tax_exempt: e.target.checked === true ? projectData?.is_tax_exempt : itemData?.is_tax_exempt,
              }));
            }} />} label="Default Tax from the Project for the item" sx={{ '& .MuiFormControlLabel-label': { fontSize: '12px' } }} />
          </FormGroup>
        </Grid>
      </Grid>
    </>
  )
}

export default Financial;